/* cro-product-card.js
 *
 * Quick-add + colour-swatch behaviour for the site product card.
 *
 * WHY THIS IS AN ASSET AND NOT AN INLINE <script> IN cro-product-card.liquid:
 * "Complete the Look" (sections/cro-recommendations.liquid) fetches Shopify's recommendations,
 * parses them with DOMParser and appendChild's the result. A <script> tag introduced that way
 * NEVER EXECUTES. So the card's inline script never ran on the product page, window.__cpcInit
 * stayed false, and nothing was bound: colour swatches did not swap the photo and Quick add did
 * nothing at all. It worked on collection pages only because those cards are server-rendered.
 *
 * As a separate file loaded by the PARENT page it runs once, and because every handler below is
 * delegated from `document` it also covers cards injected later by AJAX.
 *
 * Loaded with `defer` by any section that renders the card. The __cpcInit guard at the top makes
 * a second load harmless.
 */
(function(){
  if (window.__cpcInit) return; window.__cpcInit = true;

  function variantsOf(qa){ try{ return JSON.parse(qa.querySelector('[data-cpc-variants]').textContent); }catch(e){ return []; } }
  function openCart(){
    try{ document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true})); }catch(e){}
    // Prefer the explicit OPEN over the blind toggle, so a rapid second tap can never close the drawer.
    setTimeout(function(){ try{ if(typeof window.upcartOpenCart==='function'){ window.upcartOpenCart(); } else if(typeof window.UpcartToggleCart==='function'){ window.UpcartToggleCart(); } }catch(e){} }, 150);
  }
  function flash(qa, po){
    var f = qa.querySelector('[data-cpc-qa-flash]'), tray = qa.querySelector('[data-cpc-qa-tray]');
    if(tray) tray.hidden = true;
    if(f){ f.textContent = po ? 'Pre-order added' : 'Added to cart'; f.classList.toggle('cpc-qa-flash--preorder', !!po); f.hidden = false; setTimeout(function(){ f.hidden = true; }, po ? 2200 : 1600); }
  }
  function refreshSizes(qa){
    var data = variantsOf(qa), cpos=+qa.getAttribute('data-cpc-cpos')||0, spos=+qa.getAttribute('data-cpc-spos')||0, color=qa.getAttribute('data-cpc-color');
    var preDate = '';
    qa.querySelectorAll('[data-cpc-qa-size]').forEach(function(chip){
      var size = chip.getAttribute('data-size');
      var match = data.filter(function(v){ return (!cpos||v['o'+cpos]===color)&&(!spos||v['o'+spos]===size)&&v.av; })[0];
      var ok = !!match;
      // Sold-out chips stay CLICKABLE on purpose. A disabled <button> fires no click event, so the
      // shopper could not tell us they wanted it. Clicking one now opens the restock modal instead.
      chip.disabled = false;
      chip.classList.toggle('cpc-qa-chip--soldout', !ok);
      chip.setAttribute('data-soldout', ok ? '0' : '1');
      if (!ok) chip.setAttribute('title', 'Sold out. Tap to get notified when it is back.');
      var pre = !!(match && match.po);
      chip.classList.toggle('cpc-qa-chip--preorder', pre);
      if(pre){ chip.setAttribute('title', 'Pre-order · ships ' + match.po); preDate = match.po; }
      else { chip.removeAttribute('title'); }
    });
    // Spell out what the dot means, for the colour currently selected on this card.
    var anySoldOut = !!qa.querySelector('[data-cpc-qa-size][data-soldout="1"]');
    var note = qa.querySelector('[data-cpc-qa-note]');
    if(note){
      // Pre-order wording wins when both apply: a date is more useful than a maybe.
      if(preDate){
        note.textContent = 'Dotted sizes are pre-order · ship ' + preDate;
        note.classList.add('cpc-qa-note--preorder'); note.hidden = false;
      } else if(anySoldOut){
        note.textContent = 'Greyed sizes are sold out · tap one to get notified';
        note.classList.remove('cpc-qa-note--preorder'); note.hidden = false;
      } else { note.textContent = ''; note.classList.remove('cpc-qa-note--preorder'); note.hidden = true; }
    }
  }
  // The cart drawer renders its upsell trays already open (pinned), so nothing triggers the first paint of the pre-order
  // dots + note there; cro-cart.js calls this after the rows land (2026-09-26).
  window.cpcRefreshSizes = refreshSizes;
  function resolve(qa, size){
    var data = variantsOf(qa), cpos=+qa.getAttribute('data-cpc-cpos')||0, spos=+qa.getAttribute('data-cpc-spos')||0, color=qa.getAttribute('data-cpc-color');
    var m = data.filter(function(v){ return (!cpos||v['o'+cpos]===color)&&(!spos||v['o'+spos]===size)&&v.av; })[0];
    if(!m && !size){ m = data.filter(function(v){ return v.av; })[0]; }
    return m;
  }
  function add(qa, v){
    if(!v || !v.id) return;
    if(qa.dataset.cpcAdding === '1') return;  // in-flight guard: ignore rapid double-taps so we never add qty 2
    qa.dataset.cpcAdding = '1';
    try { document.dispatchEvent(new CustomEvent('fst:adding')); } catch(e){}  // the cart drawer opens right away with a progress bar
    var openBtn = qa.querySelector('[data-cpc-qa-open]'); if(openBtn) openBtn.classList.add('is-loading');
    var item = { id: v.id, quantity: 1 };
    if(v.po){ item.properties = { 'Ships by': v.po }; }  // pre-order marker: mirrors the PDP so every add path is consistent
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){ return r.json(); })
      .then(function(){ if(openBtn) openBtn.classList.remove('is-loading'); flash(qa, v.po); openCart(); })
      .catch(function(){ if(openBtn) openBtn.classList.remove('is-loading'); })
      .then(function(){ qa.dataset.cpcAdding = ''; });  // clear guard whether the add succeeded or failed
  }

  document.addEventListener('click', function(e){
    // 1) color swatch -> swap photo + set active color + refresh size availability
    var sw = e.target.closest('[data-cpc-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('.cpc-card, .fst-rec'); if (!card) return;  // .fst-rec = the cart drawer's upsell row
      var img = card.querySelector('[data-cpc-img]');
      if (img) { var s = sw.getAttribute('data-img'), ss = sw.getAttribute('data-srcset'); if (s) img.setAttribute('src', s); if (ss) img.setAttribute('srcset', ss); }
      var vid = sw.getAttribute('data-variant');
      if (vid) { card.querySelectorAll('.cpc-media-link, .cpc-title').forEach(function(a){ if (a.getAttribute('href')) a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?variant=' + vid); }); }
      // Colour-scoped sale (snippets/cro-sale.liquid scope "notcolor"): the swatch carries its colour's own price and
      // badge, so the card can never show a sale price for a colour the cart charges in full. Other swatches have
      // neither attribute and are left alone.
      var saleOver = document.documentElement.classList.contains('fst-sale-over');  // cached page, sale has ended
      var ph = saleOver ? null : sw.getAttribute('data-price-html');
      if (ph !== null) { var pe = card.querySelector('.cpc-price'); if (pe) pe.innerHTML = ph; }
      if (!saleOver && sw.hasAttribute('data-sale-badge')) {
        var bd = card.querySelector('[data-cpc-badge]');
        if (bd) { var bt = sw.getAttribute('data-sale-badge') || '', bb = bd.getAttribute('data-base') || ''; bd.textContent = bt || bb; bd.classList.toggle('cpc-badge--sale', !!bt); bd.hidden = !(bt || bb); }
      }
      card.querySelectorAll('[data-cpc-swatch]').forEach(function(x){ x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var qaEl = card.querySelector('[data-cpc-qa]');
      if(qaEl){ qaEl.setAttribute('data-cpc-color', sw.getAttribute('aria-label')||''); var tr=qaEl.querySelector('[data-cpc-qa-tray]'); if(tr && !tr.hidden) refreshSizes(qaEl); }
      try { card.dispatchEvent(new CustomEvent('cpc:color', { bubbles: true, detail: { color: sw.getAttribute('aria-label') || '' } })); } catch(err){}  // cart drawer rows re-price on this
      return;
    }
    // 2) "Quick add" -> reveal the size tray (or add straight away if there's nothing to choose)
    var open = e.target.closest('[data-cpc-qa-open]');
    if (open) {
      e.preventDefault();
      var qa = open.closest('[data-cpc-qa]'); if(!qa) return;
      var tray = qa.querySelector('[data-cpc-qa-tray]');
      document.querySelectorAll('[data-cpc-qa-tray]:not([data-cpc-pinned])').forEach(function(t){ if(t!==tray) t.hidden = true; });
      if(tray){ var willOpen = tray.hidden; tray.hidden = !willOpen; if(willOpen) refreshSizes(qa); }
      return;
    }
    // 3) size chip -> resolve + add
    var chip = e.target.closest('[data-cpc-qa-size]');
    if (chip && chip.getAttribute('data-soldout') === '1') {
      // Sold out -> offer the restock signup rather than doing nothing.
      e.preventDefault();
      var sqa = chip.closest('[data-cpc-qa]');
      var scard = chip.closest('.cpc-card, .cc-card, .fst-rec');
      var titleEl = scard ? scard.querySelector('.cpc-title, .cc-name, .fst-rec__title') : null;
      // Hand over the exact sold-out variant so the subscription is for the size they tapped,
      // not whatever the card happened to render with.
      var want = null;
      if (sqa) {
        var d = variantsOf(sqa), cp = +sqa.getAttribute('data-cpc-cpos')||0, sp = +sqa.getAttribute('data-cpc-spos')||0;
        var col = sqa.getAttribute('data-cpc-color'), sz = chip.getAttribute('data-size');
        want = d.filter(function(v){ return (!cp||v['o'+cp]===col)&&(!sp||v['o'+sp]===sz); })[0];
      }
      if (window.fstRestock) {
        window.fstRestock.open({
          variantId: want ? want.id : null,
          productName: titleEl ? (titleEl.textContent||'').trim() : null
        });
      }
      var st = sqa ? sqa.querySelector('[data-cpc-qa-tray]') : null; if (st) st.hidden = true;
      return;
    }
    if (chip && !chip.disabled) {
      e.preventDefault();
      var qa = chip.closest('[data-cpc-qa]'); if(!qa) return;
      var m = resolve(qa, chip.getAttribute('data-size'));
      if(m) add(qa, m);
      return;
    }
    // 4) "Add to cart" chip (product with no size option) -> add
    var addc = e.target.closest('[data-cpc-qa-add]');
    if (addc) {
      e.preventDefault();
      var qa = addc.closest('[data-cpc-qa]'); if(!qa) return;
      var m = resolve(qa, null);
      if(m) add(qa, m);
      return;
    }
    // 5) click anywhere else -> close open trays
    // pinned trays (the cart drawer's upsell rows) stay open: hiding them made the drawer's sizes untappable
    if(!e.target.closest('[data-cpc-qa]')){ document.querySelectorAll('[data-cpc-qa-tray]:not([data-cpc-pinned])').forEach(function(t){ t.hidden = true; }); }
  }, false);
})();
